
import * as utils from "../../global/utils";
import * as Helpers from "../../global/Helpers";

import * as Constants from "../../constants/Constants";

import * as AppUrls from "../../constants/AppUrls";
import { Redirect } from "react-router";
import React from 'react';
import { withTranslation } from 'react-i18next';


class SubComponent extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    state = {

        redirect: null,
        disabledButton: true,
        checkedDetail: false,
    }





    UpdateTermsAndConditionsVersion = () => {

        let UpdateTermsAndConditionsVersionResponse = utils.UpdateTermsAndConditionsVersion(this);
        UpdateTermsAndConditionsVersionResponse
            .then((response) => response.data)
            .then((data) => {

                console.log("UpdateTermsAndConditionsVersionResponse", data)
                if (data) {

                    // this.setState({ redirect: AppUrls.trading })
                    localStorage.setItem("isTermsAndConditions", 'Y');

                    this.props.onClose();
                }

            })
            .catch((error) => {
                console.log(error);
            });
    };

    render() {
        if (this.state.redirect !== null) {
            return <Redirect to={this.state.redirect} />;
        }
        var textButton = "";
        if(localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "IFS"){
            if (Number(this.props.TermsAndConditionsDate) > 0 && Number(this.props.TermsAndConditionsDate) === 1) {
                textButton = this.props.i18n.language === "ar" ? "تخطي ليوم واحد" : "Skip for " + this.props.TermsAndConditionsDate + " day"
            } else if (Number(this.props.TermsAndConditionsDate) > 0 && Number(this.props.TermsAndConditionsDate) > 1) {
                textButton = this.props.i18n.language === "ar" ? " تخطي حتى " + this.props.TermsAndConditionsDate + " يوم " : "Skip for " + this.props.TermsAndConditionsDate + " days"
    
            }
        }
       
        return (
            <>
                <div style={{ display: "flex" }}>
                    <input type="checkbox"
                        name="checkedDetail"
                        checked={this.state.checkedDetail}
                        onClick={(checked) => {

                            var disable = true;
                            if (checked.target.checked) {
                                disable = false
                            }

                            this.setState({
                                checkedDetail: checked.target.checked,
                                disabledButton: disable
                            })

                        }}>

                    </input>
                    <p
                        className="lableCustomized"
                        style={{ marginInline: "5px", marginTop: "15px" }}
                    >
                        {this.props.t("CheckboxTextTermsAndConditions")}
                    </p>
                </div>

                <div className="custom-popup-body pt-2 pb-2" style={{ width: "100%", textAlign: "initial" }} >

                    <button
                        className="btn custom-btn-primary"
                        style={{ width: "30%", maxWidth: "100px", borderRadius: "6px", marginInline: "2px" }}
                        onClick={(e) => {
                            this.UpdateTermsAndConditionsVersion();

                        }}
                        disabled={this.state.disabledButton}
                    >
                        {this.props.t("IAgree")}
                    </button>
                    {localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "IFS" ?
                        Number(this.props.TermsAndConditionsDate) > 0 ?
                            <button
                                className="btn custom-btn-primary"
                                style={{ width: "max-content",  borderRadius: "6px" }}
                                onClick={() => {
                                    localStorage.setItem("isTermsAndConditions", 'Y');
                                    this.props.onClose();
                                }}
                            // disabled={this.state.disabledButton}
                            >
                                {textButton}
                            </button>
                            : <button
                                className="btn custom-btn-primary"
                                style={{ width: "30%", maxWidth: "100px", borderRadius: "6px" }}
                                onClick={this.props.callLogOff}
                            // disabled={this.state.disabledButton}
                            >
                                {this.props.t("signout")}
                            </button>
                        :
                        <button
                            className="btn custom-btn-primary"
                            style={{ width: "30%", maxWidth: "100px", borderRadius: "6px" }}
                            onClick={this.props.callLogOff}
                        // disabled={this.state.disabledButton}
                        >
                            {this.props.t("signout")}
                        </button>
                    }


                </div>
            </>
        );
    }
}


export default (withTranslation()(SubComponent));